export default "__VITE_ASSET__217f9044__"